import script from "./SemiCustomOuter.vue?vue&type=script&setup=true&lang=js"
export * from "./SemiCustomOuter.vue?vue&type=script&setup=true&lang=js"

import "./SemiCustomOuter.vue?vue&type=style&index=0&id=446806d1&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\karuizawa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446806d1"]])

export default __exports__